export const LOGIN_SUCCESS = 'user/login';
export const LOGOUT_SUCCESS = 'user/logout';